import { useState } from 'react';
import { Modal } from '@material-ui/core';

export default function ExtendAlmaxExpiryDateModal({
  open,
  onClose,
  onExtendClicked,
}) {
  const [inputValue, setInputValue] = useState('');
  return (
    <Modal open={open} onClose={onClose}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
        <label htmlFor='extend-date-text'>Date</label>
        <input
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
          placeholder='yyyy-mm-dd'
          type='text'
          name=''
          id='extend-date-text'
          className='border-2'
        />

        <button
          onClick={() => {
            if (!inputValue) return;
            onExtendClicked(inputValue);
          }}
          className='bg-red-c3 p-1 px-2 rounded-md text-white'
        >
          Extend
        </button>
      </div>
    </Modal>
  );
}
